/* eslint-disable dot-notation */
const injectNewRelic = () => {
  const head = document.getElementsByTagName('head')[0]
  const urlPath = window.location.origin

  const snippet = document.createElement('script')
  snippet.type = 'text/javascript'
  snippet.src = `${urlPath}/js/new-relic-snippet.js`
  snippet.onload = () => {
    const event = new Event('newrelicIsOn')
    window.dispatchEvent(event)
  }
  head.appendChild(snippet)
}

interface newRelicMethods {
  noticeError: (err: Error, customAttr: { [key: string]: any }) => void
}

type newRelicError = {
  error: Error
  attributes: { [key: string]: any }
}

const savedErrors: newRelicError[] = []

const noticeError = (err: Error, attr: { [key: string]: any }) => {
  const newRelic = (window as { [key: string]: any })['newrelic'] as newRelicMethods
  if (!newRelic) {
    savedErrors.push({
      error: err,
      attributes: attr,
    })
  } else {
    newRelic.noticeError(err, attr)
  }
  return newRelic
}

type CustomAttributes = { [key: string]: any };


export const captureUserError = (err: Error, user_uuid: string, hub_uuid: string, extraAttributes: CustomAttributes = {}) => {
  const newRelic = (window as { [key: string]: any })['newrelic'] as newRelicMethods;

  const attributes = {
    user_uuid,
    hub_uuid, 
    ...extraAttributes,
  };

  if (!newRelic) {
    savedErrors.push({ error: err, attributes });
  } else {
    newRelic.noticeError(err, attributes);
  }
};

const processSavedErrors = () => {
  const newRelic = (window as { [key: string]: any })['newrelic'] as newRelicMethods;

  while (savedErrors.length) {
    const savedError = savedErrors.shift();
    if (savedError && newRelic) {
      newRelic.noticeError(savedError.error, savedError.attributes);
    }
  }
};
window.addEventListener('newrelicIsOn', processSavedErrors, false);

const newRelic = { injectNewRelic, noticeError }
export default newRelic
